<template>
    <div class="template">
        <div class="wrapper">
            <div>
                <!-- top navbar-->
                <div class="container">
                    <div class="w-100 mt-4 wd-xl">
                        <!-- START card-->
                        <h1 class="error-code w-100 text-center">{{ statusCode }}</h1>
                        <div class="text-center mb-4 default-message">
                            <div class="mb-3">
                                <em class="fa fa-wrench fa-5x text-muted"></em>
                            </div>
                            <p class="lead m-0">Algo deu errado</p>
                            <p>Não se preocupe, estamos trabalhando para solucionar o problema.</p>
                        </div>
                        <div class="text-center mb-4">
                            <!-- <span style="font-weight: bold; ">Mensagem interna: </span> -->
                            <h4 class="text-danger">{{ mensagem }}</h4>
                        </div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-custom secondary mr-3" @click="$router.go(-1)"><i class="fas fa-chevron-left mr-1"></i> Voltar</button>
                        <button v-b-toggle.details-collapse class="btn btn-custom primary">Detalhes</button>
                        <b-collapse id="details-collapse" class="mt-4">
                            <div class="card col-12 mx-auto card-danger text-left text-break">
                                <div class="block-center card-body">
                                    <div v-if="!isNullOrEmpty(statusCode)" class="error-information-inline">
                                        <p><span style="font-weight: bold; ">Status: </span>{{ statusCode }}</p>
                                    </div>
                                    <div v-if="!isNullOrEmpty(method)" class="error-information-inline">
                                        <p><span style="font-weight: bold; ">Método: </span><span class="text-uppercase">{{ method }}</span></p>
                                    </div>
                                    <div v-if="!isNullOrEmpty(responseUrl)" class="error-information-inline">
                                        <p><span style="font-weight: bold; ">URL: </span>{{ responseUrl }}</p>
                                    </div>
                                    <div v-if="!isNullOrEmpty(detalhes)" class="error-information-inline">
                                        <span style="font-weight: bold; ">Detalhes: </span>
                                        <pre class="stack-trace pre-scrollable" v-if="isJson(detalhes)" v-highlightjs><code class="json" v-html="stackTrace"></code></pre>
                                        <p v-else>{{ detalhes }}</p>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>

                <footer class="text-center w-100 mt-5">
                    <span class="mr-2">&copy;</span>
                    <span>2020</span>
                    <span class="mx-2">-</span>
                    <span>smartBrain</span>
                    <br/>
                    <span>Todos os direitos reservados</span>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import SpinnerService from '@/app/services/spinner.service';

export default {
    data() {
        return {
            mensagem: '',
            detalhes: '',
            statusCode: '',
            method: '',
            responseUrl: '',
            authorization: ''
        }
    },
    mounted() {
        this.mensagem = this.$route.params.mensagem || 'Caminho não encontrado';
        this.detalhes = this.$route.params.detalhes;
        this.statusCode = this.$route.params.statusCode || 404;
        this.method = this.$route.params.method;
        this.responseUrl = this.$route.params.responseUrl;
        this.authorization = this.$route.params.authorization;

        SpinnerService.hide();
        
        if (this.statusCode == 401) {
            this.$router.push({ name: 'Login' });
            return;
        }
    },
    methods: {
        isNullOrEmpty(string) {
            return string === null || string === undefined || string === '';
        },
        isJson(string) {
            return true;
        }
    },
    computed: {
        stackTrace() {
            let trace = JSON.parse(this.detalhes)
            if (trace.StackTraceString != undefined) {
                trace.StackTraceString = trace.StackTraceString.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>');
            }
            return trace
        }
    }
}
</script>

<style lang="scss">
    body{
        overflow: auto !important;
    }
    .template {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
    }

    .container {
        flex-grow: 1;
    }

    footer {
        flex-shrink: 0;
    }

    .error-information-inline {
        text-justify: auto;
        text-size-adjust: initial;
    }
    .error-code {
        font-size: 238px;
        z-index: 0;
        color: #00000015;

        @media (max-width: 480px) {
            font-size: 12rem;
        }
    }
    .default-message {
        margin-top: -195px;
        z-index: 2;
    }
    .stack-trace {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        background-color: #fafafa;
        padding: 10px;
    }
        
    #details-collapse > div {
        width: fit-content;
        min-width: 300px;
        .card-body {
            padding: 1rem 2rem;
        }
    }

    /* Cores para o highlight.js */
    .hljs.json {
        .hljs-string, .hljs-number {
            color: #880000;
        }

        .hljs-literal {
            color: #78A960;
        }

        .hljs-attr {
            color: #444;
        }
    }

</style>